import * as actionTypes from '../actionTypes/expertTips';

export default {
  updateExpertTipsData: (params) => ({
    type: actionTypes.UPDATE_EXPERT_TIPS,
    payload: params,
  }),
  resetExpertTipsData: (params) => ({
    type: actionTypes.RESET_EXPERT_TIPS,
    payload: params,
  }),
};
